import { render } from "./AppFolderCreate.vue?vue&type=template&id=4156ff75&scoped=true&ts=true"
import script from "./AppFolderCreate.vue?vue&type=script&lang=ts"
export * from "./AppFolderCreate.vue?vue&type=script&lang=ts"

import "./AppFolderCreate.vue?vue&type=style&index=0&id=4156ff75&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4156ff75"]])

export default __exports__